'use client';

import { type RefObject, useEffect } from 'react';
import { OBSERVER_EXTRA_TOP_OFFSET_PX } from '../../constants';

function useSentinelFetch(sentinelRef: RefObject<HTMLDivElement | null>, hasNextPage: boolean, fetchNextPage: () => void, isScrollLocked: () => boolean, stickyOffset: number) {
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !hasNextPage) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || isScrollLocked()) return;
          fetchNextPage();
        });
      },
      { rootMargin: `-${stickyOffset + OBSERVER_EXTRA_TOP_OFFSET_PX}px 0px 0px 0px` }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasNextPage, fetchNextPage, isScrollLocked, stickyOffset, sentinelRef]);
}

export { useSentinelFetch };
